import { all } from "redux-saga/effects";
import JourneySagas from "../features/journey/FeatureSagas";

export default function* sagas() {
  yield all([JourneySagas()]);
}
